import { render, staticRenderFns } from "./BlogArchives.vue?vue&type=template&id=0039d390&scoped=true&"
import script from "./BlogArchives.vue?vue&type=script&lang=js&"
export * from "./BlogArchives.vue?vue&type=script&lang=js&"
import style0 from "./BlogArchives.vue?vue&type=style&index=0&id=0039d390&lang=scss&scoped=true&"
import style1 from "./BlogArchives.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0039d390",
  null
  
)

export default component.exports